import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

// Elixir Logo from productelixir-ai.tech
const ELIXIR_LOGO = "https://www.productelixir-ai.tech/assets/Elixirlogo_1769893492761-BCKEFavv.png";

export const Navigation = ({ mobileMenuOpen, setMobileMenuOpen, onRequestDemo }) => {
  const navLinks = [
    { href: "#governance", label: "How It Works" },
    { href: "#features", label: "Features" },
    { href: "#industries", label: "Industries" },
    { href: "#waitlist", label: "Early Access" },
  ];

  return (
    <nav 
      className="fixed top-0 w-full z-50 bg-[#020617]/95 backdrop-blur-xl border-b border-slate-700/50"
      data-testid="main-navigation"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 lg:h-28 flex items-center justify-between">
        {/* Logo - Extra Large */}
        <div className="flex items-center gap-4 lg:gap-6">
          <img 
            src={ELIXIR_LOGO} 
            alt="ElixirID Logo" 
            className="h-16 w-16 lg:h-20 lg:w-20 object-contain drop-shadow-[0_0_15px_rgba(139,92,246,0.3)]"
            data-testid="logo-image"
          />
          <div className="flex flex-col">
            <div className="flex items-center gap-2 lg:gap-3">
              <span className="text-2xl lg:text-4xl font-extrabold tracking-tighter text-white uppercase leading-none">
                Elixir<span className="text-violet-400">ID</span>
              </span>
              <span 
                className="px-2 lg:px-3 py-0.5 lg:py-1 rounded-md bg-violet-600 text-white text-[7px] lg:text-[8px] font-extrabold uppercase tracking-[0.2em] lg:tracking-[0.3em] shadow-lg shadow-violet-900/40"
                data-testid="version-badge"
              >
                Core-Beta v2.5
              </span>
            </div>
            {/* Darker/more visible subheadline */}
            <span className="text-[9px] lg:text-[11px] font-bold uppercase tracking-[0.3em] lg:tracking-[0.4em] text-slate-100 mt-1.5 hidden sm:block">
              Agentic Entitlement Engine
            </span>
          </div>
        </div>

        {/* Desktop Navigation - Clean modern font */}
        <div className="hidden lg:flex items-center gap-6 xl:gap-10">
          {navLinks.map((link) => (
            <a 
              key={link.href}
              href={link.href} 
              className="text-[11px] font-medium text-slate-300 hover:text-white transition-colors uppercase tracking-[0.2em]"
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </a>
          ))}
          <Button 
            onClick={onRequestDemo}
            className="px-6 xl:px-8 py-2.5 xl:py-3 bg-violet-600 text-white text-[10px] font-semibold rounded-xl hover:bg-violet-700 transition-all shadow-2xl shadow-violet-900/40 uppercase tracking-widest"
            data-testid="request-demo-btn"
          >
            Request Demo
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="lg:hidden p-2 text-slate-300 hover:text-white transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          className="lg:hidden bg-slate-900/98 backdrop-blur-xl border-t border-slate-700/50 px-6 py-6 space-y-4"
          data-testid="mobile-menu"
        >
          {navLinks.map((link) => (
            <a 
              key={link.href}
              href={link.href} 
              className="block text-sm font-semibold text-slate-200 hover:text-violet-400 transition-colors uppercase tracking-wide py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <Button 
            onClick={() => {
              setMobileMenuOpen(false);
              onRequestDemo();
            }}
            className="w-full mt-4 px-6 py-3 bg-violet-600 text-white text-xs font-extrabold rounded-xl hover:bg-violet-700 transition-all shadow-2xl shadow-violet-900/40 uppercase tracking-widest"
          >
            Request Demo
          </Button>
        </div>
      )}
    </nav>
  );
};
